import type { GuideConfig, GuidesConfig } from "./types";

// Import individual guide configs
import buildWithAi from "./build-with-ai.json";
import platformOverview from "./platform-overview.json";
import workflowsOverview from "./workflows-overview.json";
import workflowEditor from "./workflow-editor.json";
import workflowHistory from "./workflow-history.json";
import webhooksOverview from "./webhooks-overview.json";
import metricsOverview from "./metrics-overview.json";
import templatesOverview from "./templates-overview.json";
import integrationsOverview from "./integrations-overview.json";
import walletManagement from "./wallet-management.json";
import connectorsOverview from "./connectors-overview.json";

// Aggregate all guides
export const guides: GuideConfig[] = [
  buildWithAi as GuideConfig,
  platformOverview as GuideConfig,
  workflowsOverview as GuideConfig,
  workflowEditor as GuideConfig,
  workflowHistory as GuideConfig,
  webhooksOverview as GuideConfig,
  metricsOverview as GuideConfig,
  templatesOverview as GuideConfig,
  integrationsOverview as GuideConfig,
  walletManagement as GuideConfig,
  connectorsOverview as GuideConfig,
];

export const guidesConfig: GuidesConfig = {
  version: "1.0.0",
  guides,
};

export default guidesConfig;
